import React from 'react';
import styles from './styles/CartSupport.scss';
import { FormattedMessage } from 'react-intl';

const CartSupport = () => (
    <div className={styles.container} data-tn="cart-support">
        <a href="https://support.1stdibs.com/" target="_blank">
            <FormattedMessage id="cart.support.supportLinkTitle" defaultMessage="Contact us" />
        </a>
    </div>
);

export default CartSupport;
